import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Err from "../../../../../../../routes/error";
import { mapState, mapActions } from "vuex";
import { LOAD_EDITING_DOCUMENT_FORM, SAVE_FORM_DATA } from "../../../store/lender-submit-actions";
import VueFormJsonSchema from "vue-form-json-schema";
import MaskedInput from "./formulary-controls/masked-input";
import HTMLBlock from "./formulary-controls/html-block";
import HeadingSeparator from "./formulary-controls/heading-separator";
import TextNode from "./formulary-controls/text-node";
import DateInput from "./formulary-controls/date-input";
import NoYesExplainInput from "./formulary-controls/no-yes-explain-input";
import TextAreaInput from "./formulary-controls/text-area-input";
import OptionsInput from "./formulary-controls/options-input";
import BCOptionsInput from "./formulary-controls/bc-components/bc-options-input";
import BooleanInput from "./formulary-controls/boolean-input";
import MultipleOptionsInput from "./formulary-controls/multiple-options-input";
import CustomList from "./formulary-controls/custom-list.vue";
import FormContentLoader from "./form-content-loader";
import { debounce, forOwn, pull } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    VueFormJsonSchema,
    FormContentLoader
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      saving: true,
      model: {},
      //List of possible schema ui components
      schemaComponents: {
        MaskedInput,
        DateInput,
        NoYesExplainInput,
        TextAreaInput,
        OptionsInput,
        BCOptionsInput,
        BooleanInput,
        MultipleOptionsInput,
        CustomList,
        HTMLBlock,
        HeadingSeparator,
        TextNode
      },
      vfjsOptions: {
        validate: false,
        validateOnLoad: false
      }
    };
  },
  computed: _objectSpread({}, mapState("ApplicationStore", {
    schema: state => {
      return state.editingDocumentForm.modelSchema || {};
    },
    uiSchema: state => {
      return state.editingDocumentForm.uiSchema || {};
    }
  })),
  watch: {
    "model.gPriorEncumbrances"(value) {
      const gPriorEncumbrancesValues = ["g1", "g2", "g3"];
      const gPriorEncumbrancesNoneValue = "g0";
      const lastPriority = value[value.length - 1];
      const valuesToPull = lastPriority == gPriorEncumbrancesNoneValue ? _filterInstanceProperty(value).call(value, val => _includesInstanceProperty(gPriorEncumbrancesValues).call(gPriorEncumbrancesValues, val) || _includesInstanceProperty(gPriorEncumbrancesValues).call(gPriorEncumbrancesValues, val.value)) : [gPriorEncumbrancesNoneValue];
      this.model.gPriorEncumbrances = pull(this.model.gPriorEncumbrances, ...valuesToPull);
      this.handleStateChange();
    },
    "model.disclosureInterests"(value) {
      if (value.option === "disclosureInterests0") this.model.possibleInterests = [];
      this.handleStateChange();
    }
  },
  mounted() {
    const {
      formKey,
      mortgageType,
      province
    } = this.form;
    const federal = province == "FEDERAL";
    this.LOAD_EDITING_DOCUMENT_FORM({
      applicationId: this.applicationId,
      clientUsername: this.clientUsername,
      formKey,
      federal,
      mortgageType
    }).then(formData => {
      this.loading = false;
      this.model = formData || {};
      const modelDefault = {
        string: "",
        object: {},
        array: [],
        number: null,
        boolean: null
      };
      forOwn(this.schema.properties, (value, name) => {
        if (typeof this.model[name] === "undefined") {
          this.model[name] = modelDefault[value.type] || null;
        }
      });
    }).catch(e => {
      Err.handle(e);
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_EDITING_DOCUMENT_FORM, SAVE_FORM_DATA])), {}, {
    handleStateChange: debounce(function () {
      this.$emit("saving", true);
      const {
        formKey,
        mortgageType,
        province
      } = this.form;
      this.SAVE_FORM_DATA({
        formKey,
        mortgageType,
        province,
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        formData: this.model
      }).then(() => {
        this.$emit("saving", false);
      });
    }, 500)
  })
});